<template>
    <div class="card">
        <div class="card-body">
            <h4 class="card-title hidden-xs-down">New Extra Data</h4>
            <div class="row">
                <div class="col-3">
                    <div class="form-group">
                        <label for="name">Name *</label>
                        <input
                            id="name"
                            v-model="form.name"
                            v-validate="'required'"
                            type="text"
                            data-vv-name="name"
                            data-vv-as="Name"
                            :class="{
                                'form-control': true,
                                'is-invalid': errors.has('name')
                            }"
                        />
                        <span v-show="errors.has('name')" class="invalid-feedback" role="alert">
                            <strong>{{ errors.first('name') }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <button type="button" class="btn btn-success" @click="store">Save</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            form: {}
        };
    },
    methods: {
        store() {
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    axios
                        .post('/api/superadmin/extra-data/store', this.form)
                        .then(res => {
                            this.$toastr.i(res.data.message);
                            this.$router.push({ name: 'smartfilter.ed' });
                        })
                        .catch(error => console.error(error));
                }
            });
        }
    }
};
</script>
